import styles from './ResponseWaiting.module.scss';
import { ReactComponent as UploadImage } from 'img/cloud-arrow-up-regular.svg';
import { ReactComponent as DownloadImage } from 'img/icon-download.svg';

interface Props {
  type?: 'upload' | 'download';
  message: string;
  progressMessage?: string;
}

export default function ResponseWaiting({ type = 'upload', message,progressMessage }: Props) {
  return (
    <div className={styles['response-waiting-container']}>
      {type === 'download' ? (
        <DownloadImage width={40} height={40} fill="var(--text-default)" />
      ) : (
        <UploadImage width={40} height={40} fill="var(--text-default)" />
      )}
      <div className={styles.textAnimation}>
        {message}
        <span className={styles.dot}>.</span>
        <span className={styles.dot} style={{ animationDelay: '0.1s' }}>.</span>
        <span className={styles.dot} style={{ animationDelay: '0.2s' }}>.</span>
      </div>
      { progressMessage &&
        <div className={styles.textAnimation}>
        {progressMessage}
        </div>
      }
    </div>
  );
}
